﻿export const AppContainerId = 'veilederGenerell';
